import { Link } from 'react-router';
import { FaTelegram } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FaTelegram />, href: 'https://t.me/hisphere' }
  ];

  const footerLinks = [
    {
      title: 'Компания',
      links: [
        { name: 'О нас', path: '/about' },
        { name: 'Персонал', path: '/staff' },
        { name: 'Блог', path: '/blog' },
        { name: 'Пресса', path: '/press' }
      ]
    },
    {
      title: 'Поддержка',
      links: [
        { name: 'Центр помощи', path: '/help-center' },
        { name: 'Связаться с нами', path: '/contact' },
        { name: 'Политика конфиденциальности', href: '/privacy-policy.pdf', external: true },
        { name: 'Условия', href: '/terms-of-service.pdf', external: true }
      ]
    }
  ];

  return (
    <footer className='py-20 relative overflow-hidden'>
      <div className='container mx-auto px-8 max-w-7xl relative z-10'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12'>
          <div className='animate'>
            <h3 className='text-xl font-montserrat font-bold mb-4 relative
              after:content-[""] after:absolute after:bottom-[-8px] after:left-0 after:w-12 after:h-1 after:bg-gradient-to-r after:from-cyan-400 after:to-sky-400 after:rounded'>
              О нас
            </h3>
            <p className='text-gray-400 mb-4'>
              Делаем ConnectMe, HiZip и Vithenics — три отдельных продукта под одной небольшой командой разработчиков.
            </p>
            <div className='flex gap-3'>
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className='w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white text-base hover:bg-gradient-to-br hover:from-cyan-400 hover:to-sky-500 hover:-translate-y-1 transition-all duration-200'
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
          {footerLinks.map((section, index) => (
            <div key={index} className='animate'>
              <h3 className='text-xl font-montserrat font-bold mb-4 relative
                after:content-[""] after:absolute after:bottom-[-8px] after:left-0 after:w-12 after:h-1 after:bg-gradient-to-r after:from-cyan-400 after:to-sky-400 after:rounded'>
                {section.title}
              </h3>
              <ul className='list-none'>
                {section.links.map((link, i) => (
                  <li key={i} className='mb-2'>
                    {link.external ? (
                      <a
                        href={link.href}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-200 relative
                          after:content-[""] after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-0.5 after:bg-cyan-400 after:transition-all after:duration-200 hover:after:w-full'
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className='text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-200 relative
                          after:content-[""] after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-0.5 after:bg-cyan-400 after:transition-all after:duration-200 hover:after:w-full'
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className='text-center pt-12 border-t border-white/10 text-gray-400 text-sm animate'>
          © {currentYear} HiSphere. Все права защищены.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
